import { render, staticRenderFns } from "./notSureCard.vue?vue&type=template&id=4083907c&scoped=true&"
import script from "./notSureCard.vue?vue&type=script&lang=js&"
export * from "./notSureCard.vue?vue&type=script&lang=js&"
import style0 from "./notSureCard.vue?vue&type=style&index=0&id=4083907c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4083907c",
  null
  
)

export default component.exports